import ReadiscoverPost from "./ReadiscoverPost"

const Blog = () => {
  return <ReadiscoverPost />
}

export default Blog
